import {
  checkVirtualOrganizationBind,
  checkVirtualOrganizationName,
  deleteVirtualOrganization,
  getVirtualOrganizationDetail,
  getVirtualOrganizationList,
  saveVirtualOrganization,
  searchVirtualOrganizationList,
} from '../services';

export default {
  namespace: 'virtualOrganization',
  state: {
    organizationDetail: {},
  },
  effects: {
    *changeDetail({ payload }, { put }) {
      yield put({
        type: 'update',
        payload: {
          organizationDetail: payload || {},
        },
      });
    },
    *getVirtualOrganizationList({ payload }, { call }) {
      const res = yield call(getVirtualOrganizationList, payload);
      return res;
    },
    *getVirtualOrganizationDetail({ payload }, { call, put }) {
      const res = yield call(getVirtualOrganizationDetail, payload);
      yield put({
        type: 'update',
        payload: {
          organizationDetail: res || {},
        },
      });
      return res;
    },
    *saveVirtualOrganization({ payload }, { call }) {
      const res = yield call(saveVirtualOrganization, payload);
      return res;
    },
    *checkVirtualOrganizationName({ payload }, { call }) {
      const res = yield call(checkVirtualOrganizationName, payload);
      return res;
    },
    *checkVirtualOrganizationBind({ payload }, { call }) {
      const res = yield call(checkVirtualOrganizationBind, payload);
      return res;
    },
    *deleteVirtualOrganization({ payload }, { call }) {
      const res = yield call(deleteVirtualOrganization, payload);
      return res;
    },
    *searchVirtualOrganizationList({ payload }, { call }) {
      const res = yield call(searchVirtualOrganizationList, payload);
      return res;
    },
  },
  reducers: {
    update(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
  },
};
